import {cloneDeep, has, map} from 'lodash'
import moment from 'moment'
import {useStatesGlobal} from '../../../../_gori/helpers/components/StatesGlobalProvider'
import {DIMENSION_UNIT, WEIGHT_UNIT} from '../../../../_gori/constants'
import {OrderStatus} from './_const'

const formatParcels = (parcels) => {
  if (!parcels) return {}

  return Object.entries(parcels).reduce((init, [key, value]: [any, any]) => {
    if (['length', 'width', 'height', 'weight'].includes(key)) {
      init[key] = Number(value)
    } else {
      init[key] = value
    }
    return init
  }, {})
}

const buildParcels = (parcels: any) => {
  return Object.entries(cloneDeep(parcels)).map(([key, value]: [any, any]) => {
    if (typeof value.package_type === 'object') {
      value.package_type = ''
    }
    return value
  }) as object
}

const buildRateParcels = (carriers: any, service: any, parcels: any, checkPackageType = true) => {
  let packageTypes = carriers[service]?.package_types

  return Object.entries(cloneDeep(parcels)).map(([key, value]: [any, any]) => {
    map(['length', 'width', 'height', 'weight', 'package_count'], (item) => {
      if (has(value, item)) {
        return (value[item] = Number(value[item]))
      }
    })

    if (typeof value.package_type === 'object') {
      value.package_type = ''
    } else if (typeof value.package_type === 'string' && checkPackageType) {
      if (packageTypes) {
        const valid = packageTypes.some((item) => item.value === value.package_type)
        if (!valid) {
          value.package_type = ''
        }
      } else {
        value.package_type = ''
      }
    }
    return value
  }) as object
}

const buildInternationalOption = (internationalOption: any, customItems: any) => {
  let newInternationalOption = cloneDeep(internationalOption)
  newInternationalOption.custom_items = Object.entries(cloneDeep(customItems)).map(
    ([key, value]) => value
  )

  return newInternationalOption
}

const getPackageDetails = (package_type: string, carriersPackage) => {
  for (const pkg of carriersPackage) {
    const found = pkg.value.find((item) => item.value === package_type)
    if (found) {
      return {
        fieldsHidden: found.parcel?.hidden,
        editable: found.parcel?.editable,
        packageType: found,
      }
    }
  }
  return {
    fieldsHidden: undefined,
    editable: undefined,
    packageType: null,
  }
}

const flattenParcels = (parcels) => {
  if (!parcels) return {}

  return parcels.map((item) => ({
    id: item?.id || null,
    package_type: item?.package_type || '',
    package_id: item?.package_id || null,
    weight: Number(item?.weight?.value) || null,
    weight_unit: item?.weight?.unit ?? WEIGHT_UNIT.OZ,
    length: Number(item?.dimensions?.length) || null,
    width: Number(item?.dimensions?.width) || null,
    height: Number(item?.dimensions?.height) || null,
    dimension_unit: item?.dimensions?.unit || DIMENSION_UNIT.IN,
    package_count: item?.package_count || 1,
  }))
}

export const isCreatedWithinLast30Days = (createdAt: any) => {
  if (!createdAt) return false

  return moment(createdAt).isAfter(moment().subtract(30, 'days'))
}

export const canPrintLabelOrder = (order: any) => {
  return (
    order?.status === OrderStatus.SHIPPED &&
    isCreatedWithinLast30Days(order?.latest_shipment?.created_at)
  )
}

const OrderHelper = () => {
  const {statesGlobal} = useStatesGlobal()
  const carriers = statesGlobal.carriers

  return {
    formatParcels: (parcels: any) => formatParcels(parcels),
    buildParcels: (parcels: any) => buildParcels(parcels),
    buildRateParcels: (service: any, parcels: any, checkPackageType?: boolean) =>
      buildRateParcels(carriers, service, parcels, checkPackageType),
    buildInternationalOption: (internationalOption: any, customItems: any) =>
      buildInternationalOption(internationalOption, customItems),
    getPackageDetails: (package_type: string) => {
      const carriersPackage = statesGlobal.carriersPackage
      return getPackageDetails(package_type, carriersPackage)
    },
    flattenParcels: (parcels: any) => flattenParcels(parcels),
  }
}

export default OrderHelper
